import { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { colors } from "../../../ui/color";
import { ArrivalIcon } from "../../../ui/icons/arrivalsIcon";
import { DeparturesIcon } from "../../../ui/icons/departuresIcon";
import { TaskSquareIcon } from "../../../ui/icons/taskSquareIcon";
import { HorizontalSecondaryTab } from "../../../ui/organisms/horizontalSecondaryTab";
import { Tab } from "../../../ui/organisms/tab";
import { setSelectedTabHistory } from "../slice";
import { ArrivalHistory } from "./arrivalHistory";
import { DepartureHistory } from "./departureHistory";
import { Rotation } from "./rotation";

export function HistoryFlight() {
    const reportState = useAppSelector(state => state.report)
    const dispatch = useAppDispatch()

    const viewHistoryMap = new Map<number, ReactElement>([
        [0, <DepartureHistory />],
        [1, <ArrivalHistory />],
        [2, <Rotation />]
    ])

    return (
        <>
            <HorizontalSecondaryTab>
                <Tab
                    label={"Departure"}
                    selectedSecondary={reportState.selectedTabHistory === 0}
                    onClick={() => dispatch(setSelectedTabHistory(0))}
                    type="secondary"
                    icon={<DeparturesIcon size={20} color={colors.neutral[700]} />}
                />
                <Tab
                    label={"Arrival"}
                    selectedSecondary={reportState.selectedTabHistory === 1}
                    onClick={() => dispatch(setSelectedTabHistory(1))}
                    type="secondary"
                    icon={<ArrivalIcon size={20} color={colors.neutral[700]} />}
                />
                <Tab
                    label={"Aircraft Flight History"}
                    selectedSecondary={reportState.selectedTabHistory === 2}
                    onClick={() => dispatch(setSelectedTabHistory(2))}
                    type="secondary"
                    icon={<TaskSquareIcon size={20} color={colors.neutral[700]} />}
                />
            </HorizontalSecondaryTab>
            {viewHistoryMap.get(reportState.selectedTabHistory)}
        </>
    )
}